module.exports = require('./_shared')('native-function-to-string', Function.toString);



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.12@core-js/modules/_function-to-string.js
// module id = 588
// module chunks = 39